import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent {
    @Input() value = false;
    @Input() documentId: string;
    @Input() documentType: string;
    @Output() toggleChange = new EventEmitter<{
        documentId: string;
        documentType: string;
        checked: boolean;
    }>();
    constructor() {}

    onToggleChange(event) {
        this.value = event;
        this.toggleChange.emit({
            documentId: this.documentId,
            documentType: this.documentType,
            checked: this.value,
        });
    }
}
